<template>
    <div class="mob-inject">
        <template v-if="showHome">
            <!-- 場景選擇 -->
            <scene-select
                    :no-bg="false"
                    @changeScene="loadScene"
                    :sel-scene="selectScene"
            ></scene-select>
            <!-- 添加 -->
            <add-drawer
                    :item-obj="rulerObj"
                    :title="$t('publish.tagAdd')+$t('edit.ruler.ruler')"
                    @add="addRuler"
                    :show-btn="showAddBtn"
            >
                <template #list>
                    <TPItem
                            v-for="(value, k) in rulerObj"
                            :key="k"
                            valueKey="ruler_id"
                            i-type="ruler"
                            :itemObj="value"
                            :selectedId="currRulerId"
                            :is-icon="false"
                            @click.native="onClickItem(value)"
                    ></TPItem>
                </template>
            </add-drawer>
        </template>
        <template v-if="showEditRuler">
            <AddRuler @onClickBack="onClickBack" :defaultObj="editTarget" @saveChangeData="saveRuler"></AddRuler>
        </template>
        <!-- 編輯沙盤 -->
        <edit-options
                v-if="editRulerVisible"
                :options="options"
                @returnBack="closeOptions"
                @onclick="editOptions"
        ></edit-options>
    </div>
</template>

<script>
    import { mapGetters } from "vuex";
    import SceneSelect from "../scenes/SceneSelect";
    import EditOptions from "../EditOptions";
    import AddDrawer from "../AddDrawer";
    import TPItem from "../TPItem";
    import AddRuler from "./component/AddRuler";
    export default {
        name: "index",
        components: { TPItem,SceneSelect,EditOptions,AddDrawer,AddRuler },
        data(){
            return{
                showHome: true,
                showEditRuler: false,
                selectScene: [],
                showAddBtn: true,
                editRulerVisible: false,
                editTarget: null,
                options:[
                    {title: this.$t('actionTitles.edit'), src: require('../../assets/img/mob_create.png'), type: 'edit'},
                    {title: this.$t('actionTitles.delete'), src: require('../../assets/img/mob_delete.png'), type: 'delete'},
                ],
                currRulerId:'',
                rulerObj:{},
                kr:null
            }
        },
        computed: {
            ...mapGetters([
                "vrbase",
                "currentScenesId",
            ]),
        },
        watch: {
            currentScenesId: {
                handler(newVal) {
                    this.$set(this.selectScene, 0, newVal);
                    this.rulerObj = this.vrbase.scenes[newVal].ruler
                }
            },
        },
        created() {
            this.selectScene[0] = this.currentScenesId
            this.rulerObj = this.vrbase.scenes[this.currentScenesId].ruler
            this.kr = document.getElementById('krpanoSWFObject');
        },
        methods:{
            loadScene(id){
                this.$store.dispatch("loadScene", id);
                this.closeOptions()
            },
            //關閉編輯
            closeOptions(){
                this.editRulerVisible = false
                this.showAddBtn = true
                this.currRulerId = ''
            },
            onClickBack(){
                this.showHome = true;
                this.showEditRuler = false;
                this.$emit('changeLevel','prev');
                this.currRulerId = ''
            },
            editOptions(type){
                if(type == 'edit'){
                    this.editItem()
                }
                if(type == 'delete'){
                    this.deleteItem()
                }
                this.editRulerVisible = false
                this.showAddBtn = true
            },
            deleteItem() {
                const _this=this;
                this.$confirm({
                    title: _this.$t('edit.editMessage.title'),
                    content: _this.$t('edit.editMessage.content'),
                    okText: _this.$t('edit.editMessage.okText'),
                    okType: "danger",
                    cancelText: _this.$t('edit.editMessage.cancelText'),
                    onOk() {
                       let ruler = _this.vrbase.scenes[_this.currentScenesId].ruler;
                        krMarkLine.krpano_obj = _this.kr;
                        krMarkLine.hotspot_mark.name = _this.editTarget.hotspot_mark.name
                        krMarkLine.delete()
                        _this.$delete(ruler, _this.editTarget.hotspot_mark.name);
                        _this.$delete(_this.rulerObj, _this.editTarget.hotspot_mark.name);
                        _this.$store.dispatch("setVRBase", _this.vrbase);
                    },
                    onCancel() {
                    console.log("取消");
                    },
                });
            },
            editItem() {
                this.showHome = false;
                this.showEditRuler = true;
                this.$emit('changeLevel','next');
            },
            addRuler(){
                this.editTarget = null;
                this.editRulerVisible = false;
                this.editItem()
            },
            onClickItem(item){
                this.showAddBtn = false;
                this.currRulerId = item.ruler_id;
                this.editRulerVisible = true;
                this.editTarget = item
                if(item.hotspot_desc.ath == 0 && item.hotspot_desc.atv == 0){
                    lookto(item.hotspot_mark.point[0].ath,item.hotspot_mark.point[0].atv);
                }else{
                    lookto(item.hotspot_desc.ath,item.hotspot_desc.atv);
                }
            },
            //保存標尺
            saveRuler({ key, data }) {
                let vrbase = this.vrbase;
                this.$set(this.rulerObj, key, data); // 更新本地
                this.$set(vrbase.scenes[this.currentScenesId].ruler,key,data)
                this.$store.dispatch("setVRBase", vrbase);
                this.$store.dispatch("saveVRBase", {vrbase, showLoading: true}).then(res=>{
                    this.onClickBack()
                });
            },
        }
    }
</script>

<style scoped>
.mob-inject{
    padding: 0 !important;
}
</style>
